export default "__VITE_ASSET__MiuQG2ij__"